import Api from '@/services/Api'

export default {
  GetDetails(itemId, itemType) {
    return Api().get('/search/items/' + itemType + '/' + itemId)
  }
}
